import { useSearchParams } from 'react-router-dom';

export const useExtraParams = () => {
  const [searchParams] = useSearchParams();

  const wegoInternalCampaignSearchParam = searchParams.get('wg_internal_campaign');
  const isCrossSell = wegoInternalCampaignSearchParam === 'hotels_crosssell';
  const tsCodeSearchParam = searchParams.get('ts_code');
  // Google hotel
  const wegoHotelIdSearchParam = searchParams.get('wego_hotel_id');
  const wegoPriceSearchParam = searchParams.get('wego_price');

  const bowOnlySearchParam = searchParams.get('bow_only');

  const extraBodyParams: { [key: string]: string | boolean } = {
    ...(bowOnlySearchParam === 'true' && { bowOnly: true }),
  };

  const extraSearchBodyParams: { [key: string]: string | { [key: string]: string } | boolean } = {
    ...(!!wegoInternalCampaignSearchParam && isCrossSell && { crossSell: true }),
    ...(tsCodeSearchParam !== null && { tsCode: tsCodeSearchParam }),
    ...(!!wegoHotelIdSearchParam &&
      !!wegoPriceSearchParam && {
        encryptedDisplayedPriceByHotelId: { [wegoHotelIdSearchParam]: wegoPriceSearchParam },
      }),
  };

  return { extraBodyParams, extraSearchBodyParams };
};
